<router-outlet></router-outlet>

<session-timeout
    [showModal]="authService.isSessionExpired()" 
    [timeLeft]="authService.timeLeft()"
    (continueSession)="continueSession()"
    (logout)="authService.logout()"
  >
</session-timeout>
